import * as api from 'commons/js/api'

export const createPrebooking = (prebooking) => {
    return api.createPrebooking(prebooking)
}

export const createPublicPrebooking = (prebooking) => {
    return api.createPublicPrebooking(prebooking)
}
